// extracted by mini-css-extract-plugin
module.exports = {"banner":"BalanceWarningBanner_banner__1WwH5"};